import { LenderConcession } from '../../interfaces';

export const USBank: LenderConcession = {
  lenderNameRegEx: new RegExp('US BANK'),
  standardMinimumPercent: 2.0,
  minimumDollarAmount: 25,
  apr: 4.9,
};
